import EdocatSwitch from './Switch';
export default EdocatSwitch;
